import { ApiError, OpenAPI } from '../client'
import { auth } from './firebase'

OpenAPI.BASE = import.meta.env.VITE_API_URL ?? ''
OpenAPI.TOKEN = async () => (await auth.currentUser?.getIdToken()) ?? ''

type ErrorDetail = { code?: string; message?: string }

function errorDetail(error: unknown) {
  return error instanceof ApiError ? (error.body as { detail?: unknown })?.detail : null
}

export function hasStatus(error: unknown, status: number) {
  return error instanceof ApiError && error.status === status
}

export function apiErrorCode(error: unknown) {
  const detail = errorDetail(error)
  return detail && typeof detail === 'object' ? (detail as ErrorDetail).code : undefined
}

export function apiErrorMessage(error: unknown) {
  const detail = errorDetail(error)
  if (typeof detail === 'string') return detail
  if (detail && typeof detail === 'object' && (detail as ErrorDetail).message) return (detail as ErrorDetail).message!
  if (error instanceof Error && error.message) return error.message
  return 'Something went wrong. Please try again.'
}
